<template>
  <div :id="`${source}_call_routing_toggle`">
    <a-switch size="small" :checked="isActive" @change="toToggleCallRouting" />
  </div>
</template>

<script setup>
import { ref } from "vue";
import { message } from "ant-design-vue";
import CallService from "@/src/api/CallService.js";

const props = defineProps({
  source: { type: String, required: true, default: "custom_table" },
  row: { type: Object, required: true },
  customActionKey: { type: String, required: true },
});

const isActive = ref(props.row?.[props.customActionKey] === true);

const toToggleCallRouting = async (checked) => {
  try {
    isActive.value = checked;

    const payload = {
      is_active: checked,
    };

    const response = await CallService.updateCallRoute(props.row?.id, payload);
    if (response?.success) {
      message.success(
        `Call Routing is ${isActive.value ? "enabled" : "disabled"} for ${props.row?.name}`,
      );
    }
  } catch (error) {
    isActive.value = !checked;
    message.error(
      error?.response?.data?.message ||
        "An error occurred while trying to update call routing.",
    );
    console.error(
      "An error occurred while trying to update call routing toggle: ",
      error,
    );
  }
};
</script>
